import { FC } from 'react';

import { Card } from '../../../../../shared/components/Card';
import { ComingSoonCard } from '../../../../components/ComingSoonCard';
import { ContentHeading } from '../ContentHeading';

interface RoAndAdjustedEarningsProps {
  adminUrl: string;
}

export const RoAndAdjustedEarnings: FC<RoAndAdjustedEarningsProps> = ({ adminUrl }) => {
  return (
    <Card>
      <ContentHeading icon="monetization-on-rounded" headingTitle="Ride Opportunities & Adjusted Earnings" />
      <ComingSoonCard adminUrl={adminUrl} />
    </Card>
  );
};
